import { InvoiceModel } from "@jugl-web/rest-api";
import { useCustomer } from "@jugl-web/domain-resources/customers/hooks/useCustomer";
import { TableUserCell } from "@jugl-web/ui-kit/data-display/Table";
import { useInvoicesTableContext } from "../../../context/useInvoicesTableContext";

export const CustomerCell = ({ customer_id }: InvoiceModel) => {
  const { entity, isGuest } = useInvoicesTableContext();
  const { safeCustomerDetails } = useCustomer({
    entityId: entity.id,
    customerId: customer_id ?? undefined,
    isGuest,
  });

  return <TableUserCell userName={safeCustomerDetails.fullName} />;
};
